module.exports = __webpack_public_path__ + "media/images/off_white_background_round_edges-91e4ccc50bc6ee5ec8a6f6adc1269ade.svg";